<template>
  <el-container class="container">
    <!-- 头部 -->
    <el-header class="headerStyle"><HeaderContent /></el-header>
    <!-- 中间部分 -->
    <el-main class="main_content">
      <!-- 动态详情 -->
      <div class="dynamic_details">
        <h1>藏在写字楼里的隐形成本</h1>
        <p class="author">
          <span><a>蓝海购</a></span
          ><span> 2018-07-11</span>
          <!-- <span>2018-06-11</span> -->
        </p>
        <div class="dynamics_img">
          <img src="~@/assets/images/BOSNewTwo.gif" />
        </div>
        <p style="margin: 20px auto 15px auto">
          随着ip时代的到来，人们越来越追求“颜值”“品质”“舒适性”，办公场地作为企业名片，早已不再是办公场所那么简单，其选址、外立形象、内部环境等,都间接决定了企业的发展。
        </p>
        <div class="dynamics_img dynamics_img1">
          <img src="~@/assets/images/bos6.jpg" />
        </div>
        <p>
          一位成功的老板，必定是一位精打细算的企业家。写字楼的隐形成本就如“怪兽”，但如拿捏的好，则是|
          助攻神器| 。
        </p>
        <br />
        <p class="littleStyle">城市繁华带=流量成本</p>
        <div class="dynamics_img dynamics_img2">
          <img src="~@/assets/images/bos11.webp" />
        </div>
        <p style="margin-top: 20px">
          好地段的写字楼，是高端企业、顶尖人才的汇聚之地
        </p>
        <p>更是资源、人流、信息流的辐射地带</p>
        <p>友阿总部国际大厦位于长沙市中心火车站商圈</p>
        <p>作为人流基数最大的商圈之一，这里占据了先天的流量优势</p>
        <br />
        <p class="littleStyle">交通便利=时间成本</p>
        <div class="dynamics_img dynamics_img3">
          <img src="~@/assets/images/bos12.webp" />
        </div>
        <p style="margin-bottom: 10px">在分秒必争的商务时代</p>
        <p>企业能否接轨全球繁华，完善的交通枢纽占据了或不可缺的地位</p>
        <p>友阿总部国际大厦,三轨对接30分钟全球通达</p>
        <p>地铁-公交-轻轨-高铁-机场 ，轻松掌控全球商务</p>
        <p>企业员工上下班更无忧，工作离生活更近</p>
        <br />
        <p class="littleStyle">形象品质=沟通成本</p>
        <div class="dynamics_img dynamics_img4">
          <img src="~@/assets/images/bos13.webp" />
        </div>
        <p>自古人的天性，喜爱美的事物</p>
        <p>赏心悦目、秀色可餐，再有趣的灵魂</p>
        <p>也是在好形象的引导之下</p>
        <p style="margin-bottom: 20px">才尽有可能被一一挖掘的机会</p>
        <p>友阿总部国际大厦</p>
        <p>360°无视角全通透无柱大空间</p>
        <p>LOW-E玻璃幕墙</p>
        <p>匠心铸就5A品质</p>
        <br />
        <p class="littleStyle">配套齐全=生活成本</p>
        <div class="dynamics_img dynamics_img5">
          <img src="~@/assets/images/bos14.webp" />
        </div>
        <p>谈完生意没地方用餐？员工就餐难？想去轻松一下，没地方可去？</p>
        <p>友阿总部国际大厦</p>
        <p>自带4层商业体</p>
        <p>周边五星酒店、商场超市</p>
        <p>娱乐场所、医院、学校簇拥而至。</p>
        <br /><br />
        <p class="littleStyle">5A写字楼尊贵办公体验</p>
        <div class="dynamics_img dynamics_img6">
          <img src="~@/assets/images/bos15.webp" />
        </div>
        <p>友阿总部国际大厦</p>
        <p>电梯直接入户,轻松享受帝王般的至尊体验</p>
        <p>双机位麦克维尔中央空调，令办公舒畅有加</p>
        <p>智能办公，一键开启无限可能</p>
        <p>高标准物业管理体系，以细致入微的人本主义，铸就商务关怀</p>
        <p>拓宽您成功从容的步伐.</p>
        <br />
        <div class="dynamics_img">
          <img src="~@/assets/images/bos16.webp" />
        </div>
        <div style="font-weight: 600">
          <p>对于城市里生活的我们</p>
          <p>工作已经成为我们不可分割的一部分</p>
          <p>而品质的写字楼更是成功路上的助跑器</p>
          <p>在友阿总部国际大厦</p>
          <p>即可开展一段梦寐以求的人生</p>
          <br />
        </div>
        <div class="dynamics_img dynamics_img7">
          <img src="~@/assets/images/bos2.gif" />
        </div>
        <div class="contentUn">
          <p>与友阿为邻 与财富同行</p>
          <p>蓝海购独家代理项目</p>
          <p>580㎡—1300㎡整层办公楼热销中</p>
        </div>
        <div class="dynamics_img dynamics_img8">
          <img src="~@/assets/images/bos17.webp" />
        </div>
        <p>项目地址：长沙市芙蓉区人民路与朝阳路交汇处</p>
        <p>热销热线：8229866</p>
        <br />
        <section class="codeStyle">
          <section class="codeStyleOne">
            <section class="codeStyleTwo">
              <span class="codeStyleTwoSpan"
                >蓝海购一直专注空间服务，从营建、营销到运营，全方位的帮助开发商快速解决存量及后期运营问题。</span
              >
            </section>
            <section class="codeStyleThree">
              <section class="codeStyleFour">
                <p style="text-align: left">
                  <span style="font-size: 14px"></span>
                </p>
                <section style="font-size: 16px">
                  <section style="border: 0px none; box-sizing: border-box">
                    <section style="border: 0px none; box-sizing: border-box">
                      <section style="width: 100%" data-width="100%">
                        <section class="codeStyleFive">
                          <section class="codeStyleSix">
                            <img
                              class="codeStyleSixImg"
                              src="~@/assets/images/bos18.webp"
                              crossorigin="anonymous"
                              alt="图片"
                              data-fail="0"
                            />
                          </section>
                        </section>
                      </section>
                      <section
                        style="clear: both; width: 100%"
                        data-width="100%"
                      ></section>
                    </section>
                  </section>
                  <p style="text-align: left"><br /></p>
                </section>
                <p style="text-align: left">
                  <span style="font-size: 14px"></span>
                </p>
              </section>
            </section>
            <section class="codeStyleSeven">
              <p>
                <span style="color: rgb(126, 126, 126); font-size: 14px"
                  >长按识别二维码，关注更多动态</span
                >
              </p>
            </section>
          </section>
        </section>
      </div>
      <!-- 底部 -->
      <FooterContent />
    </el-main>
  </el-container>
</template>

<style scoped lang="scss">
.headerStyle {
  height: 77px !important;
}
.main_content {
  padding: 0 !important;
  background: #f8fafc;
  .dynamic_details {
    // margin: 62px 260px 53px 260px;
    margin: 62px 232px 53px 254px;
    padding: 55px 67px 74px 61px;
    background: #fff;
    text-align: left;
    h1 {
      font-size: 30px;
      max-width: 630px;
      margin: 0 auto;
      text-align: left;
    }
    p {
      font-size: 16px;
      line-height: 32px;
    }

    div {
      text-align: center;
    }

    h3 {
      font-size: 20px;
      margin: 20px 0;
    }

    p {
      max-width: 630px;
      margin: 0 auto;
    }
    .author {
      margin-top: 10px;
      margin-bottom: 70px;
      display: flex;
      span:nth-of-type(1) {
        margin-right: 10px;
      }
      img {
        vertical-align: middle;
        margin: 0 10px;
      }
      a {
        color: #999999;
        font-size: 14px;
      }
      > span:nth-of-type(2) {
        color: #999999;
      }
    }

    .dynamics_img1 {
      img {
        max-width: 630px;
        max-height: 391px;
        margin: 0 auto;
      }
    }

    .dynamics_img2 {
      img {
        width: 600px;
        max-height: 320px;
        margin: 0 auto;
      }
    }

    .dynamics_img3 {
      img {
        width: 650px;
        max-height: 370px;
        margin: 0 auto;
      }
    }

    .dynamics_img4 {
      img {
        width: 650px;
        max-height: 437px;
        margin: 0 auto;
      }
    }

    .dynamics_img5 {
      img {
        width: 650px;
        max-height: 423px;
        margin: 0 auto;
      }
    }

    .dynamics_img6 {
      img {
        width: 650px;
        max-height: 365px;
        margin: 0 auto;
      }
    }

    .dynamics_img7 {
      img {
        width: 42px;
        max-height: 51px;
        margin: 0 auto;
      }
    }

    .dynamics_img8 {
      img {
        width: 650px;
        max-height: 827px;
        margin: 0 auto;
      }
    }

    .contentUn {
      > p:nth-of-type(1) {
        font-weight: 600;
        text-decoration: underline;
      }
    }

    .littleStyle {
      font-weight: 600;
      margin-bottom: 25px;
    }

    .codeStyle {
      letter-spacing: 0.544000029563904px;
      margin-right: auto;
      margin-left: auto;
      text-align: center;
      white-space: normal;
      widows: 1;
      border: none;
      width: 546.828125px;
      background-color: rgb(255, 255, 255);
      .codeStyleOne {
        padding-bottom: 50px;
        width: 546.828125px;
        border: 1px solid rgb(53, 49, 53);
        box-sizing: border-box;
        .codeStyleTwo {
          color: rgb(51, 51, 51);
          font-family: "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
          font-size: 17px;
          line-height: 27.2000007629395px;
          padding: 51px 34px 102px;
          width: 544.828125px;
          height: auto;
          overflow: hidden;
          box-sizing: border-box;
          text-align: left;
          background-image: initial;
          background-attachment: initial;
          background-color: rgb(53, 49, 53);
          background-size: initial;
          background-origin: initial;
          background-clip: initial;
          background-position: initial;
          background-repeat: initial;
          .codeStyleTwoSpan {
            color: rgb(255, 255, 255);
            font-family: "Hiragino Sans GB", "Microsoft YaHei", Arial,
              sans-serif;
            font-size: 14px;
            letter-spacing: 0.544000029563904px;
            line-height: 25.5px;
            widows: 1;
            background-color: rgb(53, 49, 53);
          }
        }

        .codeStyleThree {
          padding: 138px 92px 276px;
          width: 544.828125px;
          height: auto;
          overflow: hidden;
          box-sizing: border-box;
          background-image: initial;
          background-attachment: initial;
          background-color: rgb(53, 49, 53);
          background-size: initial;
          background-origin: initial;
          background-clip: initial;
          background-position: initial;
          background-repeat: initial;
          .codeStyleFour {
            color: rgb(255, 255, 255);
            font-family: "Hiragino Sans GB", "Microsoft YaHei", Arial,
              sans-serif;
            line-height: 69px;
            width: 476.828125px;
            .codeStyleFive {
              width: 300px;
              height: 306px;
              margin: 10px auto;
              overflow: hidden;
              background-image: url("~@/assets/images/bos3.jpg");
              background-size: 100%;
              background-repeat: no-repeat;
              .codeStyleSix {
                width: 130px;
                height: 130px;
                margin-top: 159px;
                margin-left: 149px;
                overflow: hidden;
                .codeStyleSixImg {
                  width: 130px !important;
                  height: auto !important;
                  visibility: visible !important;
                }
              }
            }
          }
        }

        .codeStyleSeven {
          color: rgb(51, 51, 51);
          font-family: "Hiragino Sans GB", "Microsoft YaHei", Arial, sans-serif;
          line-height: 27.2000007629395px;
          margin-top: 13px;
          margin-bottom: 13px;
          width: 544.828125px;
        }
      }
    }
  }
}
</style>

<script>
import HeaderContent from "@/components/header";
import FooterContent from "@/components/footer";

export default {
  name: "Home",
  components: {
    HeaderContent,
    FooterContent,
  },
  data() {
    return {};
  },
  methods: {},
  computed: {},
};
</script>